import React from 'react';

import { SaveOutlined } from '@ant-design/icons';

import Messages from 'i18n/messages/home';

import ButtonSmallIcon from 'common/components/button/ButtonSmallIcon';

import { useGlobalModal } from 'hooks';

import './SaveGrid.less';

const SaveGrid = (props) => {
  const { MODAL_NAMES, openModal } = useGlobalModal();

  return (
    <>
      <ButtonSmallIcon
        icon={<SaveOutlined />}
        label={Messages.saveConfig}
        onClick={() => openModal(MODAL_NAMES.CREATE_QUERY)}
        className='grid-config__button'
      />
    </>
  );
};

SaveGrid.propTypes = {};

export default SaveGrid;
